import { NgModule } from '@angular/core';
import { RefUrlPipe, AttachmentNamePipe } from '../../pipes/safe-html/safe-html.pipe';

/**
 * Pipes used by the source panel. Exported so SourcePanelModule and AppModule can import.
 */
@NgModule({
  declarations: [RefUrlPipe, AttachmentNamePipe],
  exports: [RefUrlPipe, AttachmentNamePipe]
})
export class SourcePanelPipesModule { }
